import { queryClient } from '@web/lib/query';
import { sessionState } from '@web/lib/storage';

/** Fired on `window` whenever the signed-in user changes (logout, switch user, idle timeout). */
export const SESSION_RESET_EVENT = 'kfms:session-reset';

/**
 * SEC-10: wipe everything that belongs to the previous user — React Query cache,
 * per-user session storage (`kfms.s.*`) — and notify modules holding their own state
 * (`window.addEventListener('kfms:session-reset', …)`).
 */
export function resetClientState(): void {
  queryClient.cancelQueries().catch(() => undefined);
  queryClient.clear();
  sessionState.clearAll();
  window.dispatchEvent(new CustomEvent(SESSION_RESET_EVENT));
}
